import isArray from './isArray';

export default function(_) {
  return _ != null ? (isArray(_) ? _ : [_]) : [];
}



// WEBPACK FOOTER //
// ./~/vega-util/src/array.js